export const style = {
  link: {
    height: '18px',
  },
  tableRow: {
    sx: (isDisabled: boolean, isHovered: boolean) => {
      return {
        '& .MuiTableCell-root': {
          padding: '16px 8px',
          opacity: isDisabled ? 0.5 : 1,
          pointerEvents: isDisabled ? 'none' : 'all',
        },
        '& .MuiTypography-root.MuiTypography-h6': {
          fontWeight: 600,
          fontSize: 18,
        },
        backgroundColor: isHovered ? '#f1f1fd' : '',
      };
    },
  },
  cell: {
    sx: {
      lineHeight: 1.1,
    },
  },
  cellId: {
    sx: {
      width: 150,
    },
  },
  cellPosition: {
    sx: {
      width: 100,
    },
  },
  cellRank: {
    sx: {
      maxWidth: 60,
    },
  },
  cellEQ: {
    sx: {
      maxWidth: 60,
    },
  },
  cellWtm: {
    sx: {
      maxWidth: 60,
    },
  },
  cellRunId: {
    sx: {
      maxWidth: 100,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  date: {
    sx: {
      width: 100,
    },
  },
  candidateActions: {
    sx: {
      width: 180,
    },
  },
  action: {
    sx: {
      width: 20,
    },
  },
  typography: {
    sx: {
      color: 'action.active',
    },
  },
  boxMatch: {
    box: {
      sx: {
        display: 'block',
        lineHeight: 1.1,
      },
    },
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      width: '100%',
    },
  },
  avatar: {
    variant: 'circular',
    sx: {
      color: 'primary.main',
      height: 42,
      width: 42,
    },
  },
  unDisable: {
    opacity: 1,
  },
  icons: {
    thumbsUp: {
      height: '16px',
      width: '16px',
      sx: {
        color: '#14B8A6',
      },
    },
    thumbsDown: {
      height: '16px',
      width: '16px',
      sx: {
        color: '#d14343',
      },
    },
  },
} as const;
